import { Button, Tooltip } from "@mui/material"
import { useSnackbar } from "notistack"
import Iconify from "minimals-template/components/Iconify"
import { useDialog } from "lib/@hooks/useDialog"
import { addCommentarySection } from "../controller/add-commentary-section"
import { SECTION_DIALOG_TITLE_ID, ScheduleCommentarySectionDialog } from "./schedule-commentary-section-dialog"

export function ScheduleCommentaryAddSectionButton() {
    const { enqueueSnackbar } = useSnackbar()
    const openDialog = useDialog(<ScheduleCommentarySectionDialog heading="Add section" okCaption="Add section" />, {
        "aria-labelledby": SECTION_DIALOG_TITLE_ID,
    })

    return (
        <Tooltip title="New sections are added at the bottom of the list, above any excluded commentaries">
            <Button
                variant="outlined"
                startIcon={<Iconify icon="mdi:plus" />}
                onClick={handleAdd}
                data-cy="schedule-commentary-add-section"
            >
                Add section
            </Button>
        </Tooltip>
    )

    async function handleAdd() {
        const section = await openDialog()
        if (!section) return
        try {
            await addCommentarySection(section)
            enqueueSnackbar(`Added "${section.title.trim()}"`, { variant: "success" })
        } catch (error) {
            enqueueSnackbar(error.message || "Failed to add section", { variant: "error" })
        }
    }
}
